// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1qTo6","calendarButtons":"ClockData_calendarButtons__1f-UF"};